import { useEffect, useState } from "react";

export default function Topbar({ headerContent, onMenuClick }) {
  const [isMobileWidth, setIsMobileWidth] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileWidth(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!headerContent && !isMobileWidth) {
    return null;
  }

  return (
    <div className="topbar-hero">
      {headerContent ? (
        <div className="topbar-custom-header">{headerContent}</div>
      ) : null}

      <div className="topbar__actions">
        {onMenuClick && (
          <button
            type="button"
            className="pill-btn topbar-menu-btn cairo-font"
            onClick={onMenuClick}
            aria-label="فتح القائمة الجانبية"
          >
            <i className="fa-solid fa-bars"></i>
            <span>القائمة الرئيسية</span>
          </button>
        )}
      </div>
    </div>
  );
}
